// src/firebase.ts
import { initializeApp, setLogLevel } from "firebase/app";
import { getFirestore, enableNetwork, Firestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence, inMemoryPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBU0eC4N0WUxbnKjNBDgZhRZqiUvYn6pEE",
  authDomain: "stringpak.firebaseapp.com",
  databaseURL: "https://stringpak-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "stringpak",
  storageBucket: "stringpak.firebasestorage.app",
  messagingSenderId: "106254800946",
  appId: "1:106254800946:web:c81494d3f43601e471042b",
  measurementId: "G-DY49C0N197"
};

const app = initializeApp(firebaseConfig);
try {
  setLogLevel('silent');
} catch {
  /* optional */
}

// Initialize Firestore - use simple getFirestore for reliability
// The new persistent cache can cause issues if called multiple times or in certain environments
export const db: Firestore = getFirestore(app);
export const auth = getAuth(app);

// Initialize Firebase services asynchronously to avoid blocking module initialization
if (typeof window !== 'undefined') {
  // Use setTimeout to defer initialization until after module is fully loaded
  setTimeout(() => {
    // Ensure auth state persists across page refreshes
    setPersistence(auth, browserLocalPersistence).catch((error) => {
      // IndexedDB quota/private mode often throws app/idb-set — fall back so auth still works
      const msg = error?.message || String(error);
      if (msg.includes('idb') || msg.includes('IndexedDB') || msg.includes('quota')) {
        setPersistence(auth, inMemoryPersistence).catch(() => {});
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.warn('Auth persistence fallback (in-memory):', msg);
        }
        setPersistence(auth, inMemoryPersistence).catch(() => {});
      }
    });

    // Ensure network is enabled on app start
    enableNetwork(db).catch((error) => {
      console.error('Error enabling Firestore network:', error);
    });

    // Monitor network state and re-enable network when online
    if ('navigator' in window && 'onLine' in navigator) {
      const handleOnline = () => {
        enableNetwork(db).catch((error) => {
          console.error('Error re-enabling Firestore network after coming online:', error);
        });
      };

      window.addEventListener('online', handleOnline);
      
      // Also check if already online
      if (navigator.onLine) {
        enableNetwork(db).catch((error) => {
          console.error('Error enabling Firestore network (already online):', error);
        });
      }
    }
  }, 0);
}
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

// Initialize Firebase Cloud Messaging
export const messaging = isSupported().then((supported) => {
  if (supported) {
    return getMessaging(app);
  }
  return null;
});

export default app;
